'use client';

import { m, Variants } from 'framer-motion';
import { Linkedin } from 'lucide-react';
import styles from './Team.module.css';

const teamMembers = [
    {
        name: 'Astrid Nadiya Putri',
        role: 'CEO',
        bio: 'Memimpin transformasi PT Trans Nusa Pasifik dengan visi menggabungkan keahlian operasional kargo dengan solusi teknologi digital yang inovatif.',
        initials: 'AN'
    },
    {
        name: 'Ana Lestari',
        role: 'Commissioner',
        bio: 'Mengawasi arah strategis perusahaan dan memastikan prinsip amanah serta integritas dalam setiap aspek operasional.',
        initials: 'AL'
    }
];

const containerVariants: Variants = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: { staggerChildren: 0.15 }
    }
};

const cardVariants: Variants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

export default function Team() {
    return (
        <section className={`section ${styles.team}`}>
            <div className="container">
                <m.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-100px' }}
                    transition={{ duration: 0.6 }}
                    className="section-header"
                >
                    <span className="section-label">Manajemen</span>
                    <h2 className="section-title">Tim Pemimpin Kami</h2>
                    <p className="section-subtitle">
                        Didorong oleh para profesional berpengalaman yang berdedikasi untuk memberikan keunggulan logistik.
                    </p>
                </m.div>

                <m.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: '-100px' }}
                    className={styles.grid}
                >
                    {teamMembers.map((member) => (
                        <m.div
                            key={member.name}
                            variants={cardVariants}
                            whileHover={{ y: -10 }}
                            className={styles.teamCard}
                        >
                            <div className={styles.cardHeader}>
                                <div className={styles.avatar}>
                                    {member.initials}
                                </div>
                                <div className={styles.socialOverlay}>
                                    <a href="/" className={styles.socialLink} aria-label={`LinkedIn ${member.name}`}>
                                        <Linkedin size={20} />
                                    </a>
                                </div>
                            </div>
                            <div className={styles.cardBody}>
                                <h3 className={styles.name}>{member.name}</h3>
                                <div className={styles.role}>{member.role}</div>
                                <p className={styles.bio}>{member.bio}</p>
                            </div>
                        </m.div>
                    ))}
                </m.div>
            </div>
        </section>
    );
}
